import { render, staticRenderFns } from "./DialogReference.vue?vue&type=template&id=28ac6d4d"
import script from "./DialogReference.vue?vue&type=script&lang=js"
export * from "./DialogReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports